import React from 'react';
import { css } from '@emotion/core';
import colors from '../../Styles/colors';

const favorite = css`
  position: absolute;
  right: 0;
  bottom: 4px;
  padding: 8px;
  color: #fff;
  display: flex;
  justify-content: right;
  align-items: baseline;
  transform: scale(0.999);
  z-index: 15;

  & > .fa-heart {
    font-size: 24px;
    transition: transform 400ms linear;

    &:hover {
        color: ${colors.accent};
        transform: scale(1.2);
      }
  }

  &.active {
    color: ${colors.accent};
  }
  
  .parasol-container:not(.animating) .show-teaser-wrapper.hover & {
    opacity: 1;
  }
`;

export default class AddToFavorites extends React.Component {
  trigger(action) {
    return function(e) {
      e.stopPropagation();
      e.preventDefault();
      action();
    };
  }

  render() {
    let { add, del, isFav } = this.props;

    return <div css={favorite} className={isFav ? 'active': ''}>
      {
        isFav ?
          <i className="fas fa-heart" onClick={this.trigger(del)} /> :
          <i className="far fa-heart" onClick={this.trigger(add)} />
      }
    </div>;
  }
}